import { Banner, BannerItem } from '@athena/forge';
import athenaConfig from '../../config';
import { getLocalizedString } from '../../utils/i18n-utils';
import AmplitudeUtils from '../../utils/amplitude-utils';
import Link from '../common/Link';

const { athenaNetPasswordResetUrl } = athenaConfig;

export default function InvalidUsernameOrPasswordBanner() {
  const HEADER_TEXT = getLocalizedString('errors.E0000004');
  const NON_LINK_HEADER_DESCRIPTION = getLocalizedString('invalid.username.password.description');
  const RESET_PASSWORD_LINK_TEXT = getLocalizedString('invalid.username.password.link.text');
  const DOT = '.';

  const handleResetPasswordClick = async () => {
    await AmplitudeUtils.logCustomEvent('InvalidCredentials_ResetPasswordLinkClick', {});

    // Find and trigger click on athena forgot password button
    const $forgotPasswordButton = jQueryCourage('#athena-forgot-password-link button');

    if ($forgotPasswordButton.length > 0) {
      $forgotPasswordButton.trigger('click');
    }
    else {
      // Fallback to legacy flow if athena forgot password button element not found
      window.location.assign(athenaNetPasswordResetUrl);
    }
  };

  return (
    <Banner alertType='critical' className='fe_u_padding--small'>
      <BannerItem headerText={HEADER_TEXT}>
        {NON_LINK_HEADER_DESCRIPTION}
        <Link text={RESET_PASSWORD_LINK_TEXT} href="#" onClick={handleResetPasswordClick} />
        {DOT}
      </BannerItem>
    </Banner>
  );
}
